/* Neon Arcana theme — tiny, dependency-free. Answer the Call. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Mobile nav
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.getAttribute('data-open') === 'true';
      nav.setAttribute('data-open', String(!open));
      toggle.setAttribute('aria-expanded', String(!open));
      document.body.style.overflow = open ? '' : 'hidden';
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.getAttribute('data-open') === 'true') { toggle.click(); toggle.focus(); }
    });
  }

  // Reveal on scroll
  var els = document.querySelectorAll('.reveal');
  if (reduce || !('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  // Hero pointer parallax (desktop, motion allowed)
  var hero = document.querySelector('[data-parallax]');
  if (hero && !reduce && window.matchMedia('(pointer:fine)').matches) {
    var layers = hero.querySelectorAll('[data-depth]');
    var raf = null;
    hero.addEventListener('pointermove', function (e) {
      var r = hero.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        layers.forEach(function (l) {
          var d = parseFloat(l.getAttribute('data-depth')) || 0;
          l.style.translate = (x * d * -40).toFixed(1) + 'px ' + (y * d * -40).toFixed(1) + 'px';
        });
      });
    });
  }

  // Product gallery
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var slides = g.querySelectorAll('.gallery__slide');
    var thumbs = g.querySelectorAll('.gallery__thumb');
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        slides.forEach(function (s, j) { s.classList.toggle('is-active', i === j); });
        thumbs.forEach(function (x, j) { x.setAttribute('aria-current', i === j ? 'true' : 'false'); });
      });
    });
  });

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v = b.getAttribute('data-step') === 'up' ? v + 1 : Math.max(parseInt(input.min || '0', 10), v - 1);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Click-to-load embeds (no third-party requests until the user asks)
  document.querySelectorAll('[data-embed-src]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var f = document.createElement('iframe');
      f.src = btn.getAttribute('data-embed-src');
      f.title = btn.getAttribute('data-embed-title') || 'Embedded player';
      f.width = '100%'; f.height = btn.getAttribute('data-embed-height') || '352';
      f.loading = 'lazy';
      f.allow = 'autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture';
      f.style.border = '0'; f.style.borderRadius = '12px';
      btn.replaceWith(f);
    });
  });
})();
